import * as React from 'react';
import type { Fact } from './GameBar.tsx';

// The game's summary (2026-10-19): a sheet under the review's game bar,
// over the three columns, opened by the bar's Summary button. The bar stays
// where it is; the review stays mounted underneath, so the board's position,
// a line of the reader's own or a puzzle in progress survive a look. At the
// top the game's particulars (what "More" showed under the bar until then),
// then each stage's row of cards on this game, the same as Home's (filled
// through `review.summary` by plugin shared-last-game). Presentational: the
// container places it (`style`, measured from the bar) and closes it.

export interface SummarySheetProps {
  /** The game's particulars, label over value. */
  facts: Fact[];
  /** The stages' rows. */
  children?: React.ReactNode;
  id?: string;
  /** Where the sheet sits: the container measures the bar and passes top, left and width. */
  style?: React.CSSProperties;
}

export const SummarySheet: React.FC<SummarySheetProps> = ({ facts, children, id, style }) => (
  <section id={id} className="game-summary" aria-label="Game summary" style={style}>
    {facts.length > 0 && (
      <dl className="game-bar-facts game-summary-facts">
        {facts.map((fact) => (
          <div key={fact.label} className="game-bar-fact" aria-label={`${fact.label}: ${fact.value}`}>
            <dt>{fact.label}</dt>
            <dd>{fact.value}</dd>
          </div>
        ))}
      </dl>
    )}
    <div className="game-summary-stages">{children}</div>
  </section>
);
